import { Loader2Icon } from 'lucide-react';
import { useVoiceCopy } from '@/platform/voice/use-voice';
import { Link, useParams } from 'react-router';

import { Button } from '@/components/ui/button';
import { useAppPaths } from '@/products/helpdesk/features/portal/portal-paths';
import { useKbArticle } from '@/products/helpdesk/features/kb/use-kb';
import { ApiRequestError } from '@/lib/api';

export function PortalKbArticlePage() {
  const copy = useVoiceCopy();
  const { slug = '' } = useParams();
  const paths = useAppPaths();
  const article = useKbArticle(slug);

  if (article.isPending) {
    return (
      <p className="flex items-center gap-2 text-muted-foreground">
        <Loader2Icon className="size-4 animate-spin" aria-hidden />
        Die Anleitung wird geladen …
      </p>
    );
  }

  if (article.isError || !article.data) {
    return (
      <section className="space-y-3">
        <h1 className="text-2xl font-bold">Anleitung nicht gefunden</h1>
        <p className="text-muted-foreground">
          {article.error instanceof ApiRequestError
            ? article.error.message
            : 'Diese Seite gibt es nicht oder sie ist nur für die IT sichtbar.'}
        </p>
        <Button asChild variant="outline">
          <Link to={paths.wissen}>Zurück zur Hilfe</Link>
        </Button>
      </section>
    );
  }

  const data = article.data;

  return (
    <article className="mx-auto max-w-3xl space-y-6">
      <div>
        <Button asChild variant="ghost" size="sm" className="mb-1 -ml-2">
          <Link to={paths.wissen}>← Alle Anleitungen</Link>
        </Button>
        <p className="text-sm text-muted-foreground">{data.category?.name ?? 'Hilfe'}</p>
        <h1 className="text-2xl font-bold tracking-tight">{data.title}</h1>
        {data.summary && <p className="mt-2 text-muted-foreground">{data.summary}</p>}
      </div>

      <div
        className="ticket-prose rounded-md border bg-card p-5"
        dangerouslySetInnerHTML={{ __html: data.body }}
      />

      <div className="space-y-3 rounded-md bg-muted/60 p-4">
        <p className="font-medium">{copy('helpdesk.portal.article.unsolved')}</p>
        <p className="text-sm text-muted-foreground">{copy('helpdesk.portal.article.ask')}</p>
        <Button asChild>
          <Link to={paths.ticketNew}>Anfrage an die IT stellen</Link>
        </Button>
      </div>
    </article>
  );
}
